module.exports = __webpack_public_path__ + "img/Toolbar_Right.9396132a.svg";